// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mds-combo-box__field-error-wrapper_Uz1NL {\n  display: block;\n}", "",{"version":3,"sources":["webpack://./node_modules/@mds/combo-box/src/combo-box.vue","webpack://./combo-box.vue"],"names":[],"mappings":"AAEA;EACI,cAAA;ACDJ","sourcesContent":["$mds-font-asset-path: \"https://al-fonts-prod.al1cd9f.eas.morningstar.com/\";\n\n.mds-combo-box__field-error-wrapper {\n    display: block;\n}\n",".mds-combo-box__field-error-wrapper {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mds-combo-box__field-error-wrapper": "mds-combo-box__field-error-wrapper_Uz1NL"
};
export default ___CSS_LOADER_EXPORT___;
